/* global register_guest_login */
/* global wc_cart_params */
/* global store_credit_params */

export default {
  init() {
    gotToGuestLoginPage();
    initializeMaintenanceProductsModal();
  },
  finalize() {
    coupon_ajax();
    show_coupon_button();
    // JavaScript to be fired on the checkout page, after the init JS

    $(document.body).on('updated_cart_totals', function() {
      initializeMaintenanceProductsModal();
      coupon_ajax();
      show_coupon_button();
    });
  },
};

export var gotToGuestLoginPage = () => {

  $('.checkout-button').on('click', function(e) {
    e.preventDefault();
    window.location.replace(register_guest_login.redirect_url);
  });
}

export var initializeMaintenanceProductsModal = () => {
  let maintenanceProductsModal = $('.maintenance-products-modal').wsModal();

  $('.show-maintenance').click(function () {
    maintenanceProductsModal.wsModal('open');
    $('.maintenance-products h2 .product-name').text($(this).attr('data-product'));
    $('.maintenance-products-content').empty();
    $('.maintenance-products-content').append($(this).closest('.cart_item').find('.product-maintenance-products').html());
  });
}

export var coupon_ajax = () => {
  $(document).on('click', '#coupon_code_button', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    let coupon_code = $('#coupon_code').val();

    apply_coupon(coupon_code);
  });
};

export var show_coupon_button = () => {
  $(document).on('focus', '#coupon_code', function () {
    // $('#coupon_code_button').slideDown('slow');
    // $('#coupon_code_button').css('display', 'flex');
    $(document).on('keypress', '#coupon_code', function (e) {
      if (e.which === 13) {
        e.preventDefault();
        e.stopImmediatePropagation();
        let coupon_code = $('#coupon_code').val();

        apply_coupon(coupon_code);
      }
    })
  });

  $('.coupon_form .coupon_form_toggle').click(function () {
    $(this).parent().toggleClass('open');
  });
}

export var apply_coupon = (coupon_code) => {
  $.ajax({
    type: 'POST',
    url: store_credit_params.wc_ajax_url.replace('%%endpoint%%', 'ws_apply_coupon'),
    data: {
      'coupon_code': coupon_code,
      'security': wc_cart_params.apply_coupon_nonce,
    },
  })
    .done(function(response) {
      if (response.data !== true) {
        console.log('Invalid coupon:', response);
      }
      $(document.body).trigger('wc_update_cart');
    })
    .fail(function() {
      $(document.body).trigger('wc_update_cart');
    });
};
